export default {
  header: {
    title: 'Usar os seus pontos',
    balance: '{{value}} pts disponíveis',
  },
  option_label: '{{value}} pts',
  buttons: {
    none: 'Nenhum',
  },
  toasts: {
    enabled: 'Pontos de fidelidade aplicados com sucesso',
    removed: 'Pontos de fidelidade removidos',
  },
};
